<template>
  <div class="trans-pro-main">
    <div class="trans-pro-main-head">
      <div class="trans-pro-main-head-font">
        汇集全球海量人才资源
        <br/>
        打造权威翻译团队
      </div>
      <div class="trans-pro-main-head-info">
        <div class="trans-pro-main-head-info-font">
          <div>联合国语言服务供应商</div>
          <div>中国翻译协会理事单位</div>
        </div>
        <div class="trans-pro-main-head-info-font">
          <div>汇集全球海量人才资源</div>
          <div>38年专业翻译经验</div>
        </div>
      </div>
    </div>
    <div class="trans-pro-main-lj">
      <div class="trans-pro-main-lj-wen"/>
      <div class="trans-pro-main-lj-zyfy">
        专业翻译
      </div>
      <div class="trans-pro-main-lj-money">
        最低 <span style="color: #E25900">0.12</span> 元/字
      </div>
      <div class="trans-pro-main-lj-tip">
        <div class="trans-pro-main-lj-tip-font">
          <div><img src="../../assets/H5/trans-pro-lj.png" alt=""/>20+语种翻译</div>
          <div><img src="../../assets/H5/trans-pro-lj.png" alt=""/>专业审校</div>
        </div>
        <div class="trans-pro-main-lj-tip-font">
          <div><img src="../../assets/H5/trans-pro-lj.png" alt=""/>多年翻译经验</div>
          <div><img src="../../assets/H5/trans-pro-lj.png" alt=""/>精心编排</div>
        </div>
      </div>
      <div class="trans-pro-main-hr"></div>
      <div class="trans-pro-main-lj-desc">
        <div class="trans-pro-main-lj-desc-tip-font">
          <div>专业论文</div>
          <div>简历简介</div>
          <div>证件资料</div>
        </div>
        <div class="trans-pro-main-lj-desc-tip-font">
          <div>合同标书</div>
          <div>留学移民</div>
          <div>公司介绍</div>
        </div>
        <div class="trans-pro-main-lj-desc-tip-font">
          <div>文献出版</div>
          <div>创意翻译</div>
          <div></div>
        </div>
      </div>
      <div class="trans-pro-main-lj-button" data-track-text="H5立即上传专业翻译" aria-label="H5立即上传专业翻译" @click="toPath('/h5/trans-doc')">
        <span>立即上传</span>
      </div>
    </div>
    <div class="trans-pro-main-lj" style="margin-top: 36px;margin-bottom: 30px">
      <div class="trans-pro-main-lj-wen"/>
      <div class="trans-pro-main-lj-zyfy">
        英文母语润色
      </div>
      <div class="trans-pro-main-lj-money">
        专业母语润色 | 审校+质检服务
      </div>
      <div class="trans-pro-main-lj-tip">
        <div class="trans-pro-main-lj-tip-font">
          <div><img src="../../assets/H5/trans-pro-lj.png" alt=""/>英语母语编辑</div>
          <div><img src="../../assets/H5/trans-pro-lj.png" alt=""/>语法检查</div>
        </div>
        <div class="trans-pro-main-lj-tip-font">
          <div><img src="../../assets/H5/trans-pro-lj.png" alt=""/>学术检查</div>
          <div><img src="../../assets/H5/trans-pro-lj.png" alt=""/>逻辑检查</div>
        </div>
      </div>
      <div class="trans-pro-main-hr"></div>
      <div class="trans-pro-main-lj-desc">
        <div class="trans-pro-main-lj-desc-tip-font">
          <div>SCI论文</div>
          <div>学位论文</div>
          <div>大会发言</div>
        </div>
        <div class="trans-pro-main-lj-desc-tip-font">
          <div>出版刊物</div>
          <div>企业宣传</div>
          <div>工作汇报</div>
        </div>
      </div>
      <div class="trans-pro-main-lj-button" data-track-text="H5立即下单英文润色" aria-label="H5立即下单英文润色" @click="toPath('/h5/trans-polish')">
        <span>立即下单</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TransPro",
  methods: {
    toPath(uri) {
      this.$router.push(uri)
    }
  }
}
</script>

<style lang="less" scoped>
.trans-pro-main {
  min-width: 765px;
  width: 100%;
  background: #ffffff;
  display: flex;
  flex-flow: column;
  align-items: center;

  .trans-pro-main-head {
    width: 100%;
    height: 435px;
    display: flex;
    align-items: center;
    flex-flow: column;
    background: url("../../assets/H5/trans-pro-bac.png") #F5F5F5 no-repeat;
    background-size: 768px;
    background-position: center;

    .trans-pro-main-head-font {
      margin-top: 54px;
      margin-bottom: 35px;
      font-size: 36px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 48px;
      width: 457px;
    }

    .trans-pro-main-head-info {
      width: 457px;
      height: 75px;
      background: #DDDDDD;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-flow: column;

      .trans-pro-main-head-info-font {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        line-height: 30px;
        display: flex;
        width: 457px;

        div {
          flex: 1;
        }

        div:nth-child(1) {
          margin-left: 20px;
        }
      }
    }
  }

  .trans-pro-main-lj {
    width: 709px;
    height: 685px;
    background: url("../../assets/H5/pro-zy.png") no-repeat;
    margin-top: -109px;
    display: flex;
    align-items: center;
    flex-flow: column;

    .trans-pro-main-lj-wen {
      margin-top: 34px;
      width: 122px;
      height: 122px;
      background: url("../../assets/H5/pro-zy-wen.png") no-repeat;
    }

    .trans-pro-main-lj-zyfy {
      font-size: 30px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #2F2F2F;
      margin-top: 25px;
    }

    .trans-pro-main-lj-money {
      margin-top: 14px;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #8A8989;
    }

    .trans-pro-main-lj-tip {
      width: 359px;
      height: 71px;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #999999;
      margin-top: 44px;
      line-height: 48px;

      .trans-pro-main-lj-tip-font {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        line-height: 30px;
        display: flex;
        width: 370px;
        margin-bottom: 23px;

        div {
          flex: 1;
          display: flex;
          align-items: center;

          img {
            margin-right: 18px;
          }
        }

      }
    }

    .trans-pro-main-hr {
      margin-top: 25px;
      width: 581px;
      height: 1px;
      border: 1px solid #999999;
      opacity: 0.6;
      background: #999999;
    }

    .trans-pro-main-lj-desc {
      margin-top: 28px;
      width: 481px;
      height: 110px;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #999999;
      line-height: 48px;
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;

      .trans-pro-main-lj-desc-tip-font {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        line-height: 30px;
        display: flex;
        width: 530px;
        margin-bottom: 10px;

        div {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            margin-right: 18px;
          }
        }

      }
    }

    .trans-pro-main-lj-button {
      margin-top: 30px;
      width: 261px;
      height: 60px;
      background: #063F95;
      border-radius: 35px 0px 35px 0px;
      text-align: center;

      span {
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 56px;
      }
    }
  }
}

</style>
